import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore/lite';

import { environment } from '../environments/config';

export const app = initializeApp(
  environment.firebase,
  // Specify app name to avoid conflicts with other apps on the same page
  'project-octopus',
);
export const db = getFirestore(app);
